// extracted by mini-css-extract-plugin
module.exports = {"fullChart":"FullChart_fullChart__37K0Y","chartBlock":"FullChart_chartBlock__3oVdF"};